// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pSqgw","whatsapp":"styles_whatsapp__nTskz"};